import * as Pioneer from 'pioneer';

import { poiStore } from '../managers/globalState';
import { Config } from '../config/config';

import { POI_CATEGORIES, POI_LATEST_LIMIT} from '../config/constants';
import globalRefs from '../managers/globalRefs';

//import momenti from "moment-hijri";
import moment from 'moment-timezone';
import ar from '../languages/ar';
import { event } from 'jquery';

const updateYear = newYearIndex => {
	poiStore.setGlobalState({ yearIndex: newYearIndex });
};

const updateCategory = category => {
	poiStore.setGlobalState({ categoryIndex: category });
};

/**
 * Loops through all the poi and creates an array of all years spanning them.
 * @param {Array} allPoI
 * @returns {Array}
 */
const  getAllYearsPoI = allPoI => {
	let allYears = [[ar.all_years]];

	allPoI.map(poi => {
		const currYear = poi.date.substring(0, 4);
		let all = allYears.filter(v => {
			return v[0] == currYear
		})
		if(all.length == 0){
			const display = moment(poi.date).locale('en'). format('YYYY');
			allYears.push([currYear,display]);
		}
	});

	return allYears.sort((a, b) => b - a);
};

const filterPoI = ( pois, poiYears, yearIndex, poicategoryIndex) => {
	let ret_val =  pois?.filter(poi => {
		if(POI_CATEGORIES.length > 0){
			const year = poiYears[yearIndex][0];
			const category = POI_CATEGORIES[poicategoryIndex];
			const yearFilter = year === ar.all_years || poi.date.substring(0, 4) === year;
			const categoryFilter = category[0] === 'all' || (poi.imagecategory?.includes(category[0].replace(/ /g, '').toLocaleLowerCase()));
			return yearFilter && categoryFilter;
		}
	})

	return ret_val;
};

/**
 * Load the texture of the given event.
 * @param {object} eventData
 */
let poiAuthenticationExpiresAt = 0;

const loadPoi = async (eventData, { authenticate, signal, onAuthorized, onReady } = {}) => {
  // Protect this API POI here so its texture is never requested before login.
  if (eventData?.requiresAuthentication && Date.now() >= poiAuthenticationExpiresAt) {
    if (!authenticate || !await authenticate() || signal?.aborted) {
      return;
    }
    poiAuthenticationExpiresAt = Date.now() + 5 * 60 * 1000;
  }
  if (signal?.aborted) {
    return;
  }
  onAuthorized?.();
	const { pioneer } = globalRefs;
	const { image_src, north_boundary, south_boundary, east_boundary, west_boundary,distance_from_poi } = eventData || {};
	const lowerLeftLLA = new Pioneer.LatLonAlt();
	const upperRightLLA = new Pioneer.LatLonAlt();
	const src = `${Config.baseCe2s2Url}${image_src}`
  // console.log("loadPoi start",eventData)
  const scene = pioneer.getScene('main')

  const earth = scene.getEntity('earth')
  lowerLeftLLA.set(Pioneer.MathUtils.degToRad(parseFloat(south_boundary)), Pioneer.MathUtils.degToRad(parseFloat(west_boundary)), 0, false);
  upperRightLLA.set(Pioneer.MathUtils.degToRad(parseFloat(north_boundary)), Pioneer.MathUtils.degToRad(parseFloat(east_boundary)), 0, false);

  // There's an issue where the patch component starts shaking for small boundaries. This component should be used in that scenario.
  const earthSpheroidComponent = earth.getComponent(Pioneer.SpheroidComponent);
  const centerLLA = new Pioneer.LatLonAlt((lowerLeftLLA.lat + upperRightLLA.lat) / 2, (lowerLeftLLA.lon + upperRightLLA.lon) / 2, 0);
  const center = new Pioneer.Vector3();
  earthSpheroidComponent.xyzFromLLA(center, centerLLA);

  let fixed, spheroidComponent, spheroidLODComponent

  let earthPatch = scene.getEntity('earth_patch')
  if(earthPatch){
    fixed = earthPatch.getController(Pioneer.FixedController)
    spheroidLODComponent = earthPatch.getComponent(Pioneer.SpheroidLODComponent, 'poi_patch_lod')
    spheroidLODComponent._unloadResources()
  } else {
    earthPatch = scene.addEntity('earth_patch');
    earthPatch.setParent(earth);
    fixed = earthPatch.addController(Pioneer.FixedController);
    
    earthPatch.addController(Pioneer.RotateByEntityOrientationController);
    spheroidComponent = earthPatch.addComponent(Pioneer.SpheroidComponent, 'poi_patch_sc');
    spheroidLODComponent = earthPatch.addComponent(Pioneer.SpheroidLODComponent, 'poi_patch_lod');
    spheroidComponent.setEquatorialRadius(earthSpheroidComponent.getEquatorialRadius() + .01);
    spheroidComponent.setPolarRadius(earthSpheroidComponent.getPolarRadius() + .01);
    spheroidComponent.setPlanetographic(true)
    spheroidLODComponent.setSpheroidReference('poi_patch_sc');
  }
  fixed.setPosition(center);
  fixed.setOrientation(Pioneer.Quaternion.Identity);
  spheroidLODComponent.setTexture('color', src);
  spheroidLODComponent.setBounds(lowerLeftLLA, upperRightLLA);
  spheroidLODComponent.setResourcesLoadedCallback(() => {
    const obj = spheroidLODComponent.getThreeJsObjects()[0];
    const array = obj.geometry.getAttribute('position').array;
    for (let i = 0; i < array.length; i += 3) {
      array[i + 0] -= center.x;
      array[i + 1] -= center.y;
      array[i + 2] -= center.z;
    }
  });
  //tweak the FOV to zoom into small patches
  const cameraComponent = scene.getEntity('camera').getComponent(Pioneer.CameraComponent)
  cameraComponent._fieldOfView = distance_from_poi ? distance_from_poi : cameraComponent._fieldOfView;

// Show data patch.
  spheroidLODComponent.setEnabled(true);
  spheroidLODComponent.setRenderingEnabled(true);

	// Wait until patch is loaded.
  try {
    await earth.waitTillInPlace();
    await earthPatch.waitTillInPlace();
    if (signal?.aborted) return;
    // Publish the POI only after its patch position and camera FOV are ready.
    onReady?.();
    await earthPatch.getLoadedPromise(true, 20);


  } catch (e) {
    console.warn('e: ', e);
  }
  
};

/**
	 * Enables the most recent event placemarks.
	 * @param {number} number
	 */
const getLimitedPois = (limit = POI_LATEST_LIMIT, currentPoiId = null) => {
	const { pois } = poiStore.stateSnapshot;

	try {
		if (!Array.isArray(pois) || pois.length === 0) {
			return [];
		}

		if (currentPoiId) {
			const currentIndex = pois.findIndex(poi =>
				poi.external_id === currentPoiId || poi.id === currentPoiId
			);

			if (currentIndex !== -1) {
				return pois.slice(currentIndex + 1, currentIndex + 1 + limit);
			}
		}

		return pois.filter((event, i) => i < limit);
	} catch (e) {
		console.log('missing pois', e.message);
		return [];
	}
};


export {
	updateYear,
	updateCategory,
	getAllYearsPoI,
	loadPoi,
	filterPoI,
	getLimitedPois
};
